import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { toast } from "sonner";
import { EnvelopeSimple, CheckCircle } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await fetch(`${API}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!r.ok) {
        const data = await r.json().catch(() => ({}));
        throw new Error(data.detail || "Could not send reset link");
      }
      setDone(true);
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header minimal />
      <div className="max-w-[560px] mx-auto px-6 py-16">
        <div className="pg-overline mb-4">Password reset</div>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight mb-3">Forgot your password?</h1>
        <p className="text-sm text-[#52525b] mb-8 leading-relaxed">
          No worries. Pop your email below and we'll send you a link to set a new one.
        </p>

        {done ? (
          <div className="border-2 border-[#16A34A] bg-white p-8 flex flex-col items-center text-center" data-testid="forgot-success">
            <CheckCircle size={48} weight="fill" color="#16A34A" />
            <h2 className="font-heading text-2xl font-extrabold tracking-tight mt-4">Check your inbox.</h2>
            <p className="text-sm text-[#52525b] mt-2 max-w-sm">
              If <span className="font-bold">{email}</span> is registered with PriceGuard NZ,
              we've sent a password reset link. It works for one hour.
            </p>
            <Link to="/login" className="mt-6 text-sm font-bold text-[#002FA7] underline" data-testid="forgot-back-to-login">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <label className="block">
              <span className="pg-overline">Your email</span>
              <div className="mt-2 flex items-center border border-[#e4e4e7] focus-within:border-[#002FA7]">
                <EnvelopeSimple size={18} className="mx-3 text-[#52525b]" />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 py-3 pr-3 outline-none bg-white text-sm"
                  placeholder="you@example.co.nz"
                  data-testid="forgot-email-input"
                />
              </div>
            </label>
            <button
              type="submit"
              disabled={busy}
              className="mt-5 w-full bg-[#002FA7] text-white font-bold px-6 py-3 hover:bg-[#00207A] disabled:opacity-60"
              data-testid="forgot-submit-btn"
            >
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <p className="text-sm text-[#52525b] mt-6">
              Remembered it? <Link to="/login" className="font-bold text-black underline">Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
